export const numberToLetter = (num) => {
  const number = Number(num);

  if (number === 0) return '기본';
  return String.fromCharCode(64 + number);
};
